import { MENU_SHOW, MENU_HIDE } from "../store/config";

export const hideMenu = () => {
	return {
		type: MENU_HIDE,
		payload: false,
		timestamp: Date.now()
	}
}

export const showMenu = () => {
	return {
		type: MENU_SHOW,
		payload: true,
		timestamp: Date.now()
	}
}


// WEBPACK FOOTER //
// ./src/actions/menu.js